import React from 'react';
import { Box } from '@mui/material';
import 'react-alice-carousel/lib/alice-carousel.css'; // requires a loader
import AliceCarousel from 'react-alice-carousel';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
const data = [
	{
		title: 'Chalo Thailand',
		day: 5,
		night: 4,
		image:
			'https://cdn.yourholiday.me/static/dynimg/itinerary/52/600x300/2959822-2959821_pattaya.jpg',
		amount: '30,499',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/itinerary/52/600x300/2959822-2959821_pattaya.jpg',
		],
		Itinerary: [
			{
				title: 'Day 1: Arrival In Bangkok - Transfer To Pattaya',
				desc: 'Upon arrival at Bangkok, meet our representative at airport. You will be transfered to your hotel in Pattaya. Check-in and relax for some time.',
			},
			{
				title: 'Day 2: Coral Island Tour With Lunch',
				desc: 'After breakfast at the hotel, you will be picked up and head to Pattaya Beach where the speedboat takes you over to the beautiful Koh Larn Coral Island. As you arrive, be amazed by its vast white-sand beaches and crystal-clear blue water. Plan your stay how you like it—either relax on the beach, snooze in the sun, swim in the ocean, or try out some water sports, including waterskiing, parasailing, and windsurfing (for an additional fee and subject to availability). After working up an appetite, enjoy a delicious lunch of Thai dishes at a basic, yet pleasant, open-air restaurant right next to the beach. After an action-packed or relaxed day, the speedboat brings you back to Pattaya Beach, where your shuttle bus returns you to your hotel. Rest of the day is free for you to relax and enjoy Pattaya.',
			},
			{
				title: 'Day 3:  At Leisure',
				desc: 'This is your day at leisure in Pattaya. You can choose to go on an optional tour to Coral Island, where you can lounge, swim or snorkel at the island’s immaculate golden beaches. Alternatively you can choose sightseeings such as Noong Nooch Village or visit the Sri Racha Tiger Zoo or the Underwater World in Pattaya. Overnight stay at hotel.',
			},
			{
				title: 'Day 4: Transfer From Pattaya To Bangkok',
				desc: 'Today after breakfast, check-out from your hotel. You will be picked up and transfered to Bangkok. Later check-in to your hotel and spend the evening at leisure. Overnight stay at hotel.',
			},
			{
				title: 'Day 5: Departure From Bangkok',
				desc: 'Today after breakfast, check-out from your hotel. If your flight is in the evening you can spend the day doing some shopping at Pratunam or visiting one of the popular malls like Platinum Fashion Mall or MBK Center. Later you will be transfered to the Airport to catch your return flight back home.',
			},
		],
		flight: [
			{
				dep: 'Delhi (DEL)',
				deptime: '08:15 ',
				arr: 'Bangkok (BKK)',
				arrtime: '14:05',
				airline: 'UK',
			},
			{
				dep: 'Bangkok (BKK)',
				deptime: '15:05 ',
				arr: 'Delhi (DEL)',
				arrtime: '18:20',
				airline: 'UK',
			},
		],
		accommodation: [
			{
				roomType: 'Standard',
				name: 'GLOW Pattaya or Similar',
				meal: 'Breakfast',
				night: '3N',
			},
			{
				roomType: 'Standard',
				name: 'Royal Suite Hotel Bangkok - SHA Extra Plus or Similar',
				meal: 'Breakfast',
				night: '1N',
			},
		],
	},
	{
		title: 'Delight Krabi and Phuket with Flights',
		day: 6,
		night: 5,
		image:
			'https://cdn.yourholiday.me/static/dynimg/destination/57/600x300/1722397-1722396_2jpg.jpg',
		amount: '51,699',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/destination/57/600x300/1722397-1722396_2jpg.jpg',
		],
		Itinerary: [
			{
				title: 'Day 1: Arrival At Phuket - Transfer To Krabi',
				desc: 'Upon arrival at Phuket Airport, meet our local tour coordinator who will meet and greet you at the specified area and transfer you to your Krabi hotel. Check in to your hotel (Standard Check in time: 1400 - 1500 hours) and relax. Rest of the day is free at your own leisure. In the evening you can go out and get acquainted to your nearby areas and relish some freshly made cuisines at local seaside restaurants. Later return to hotel and sleep relaxed.',
			},
			{
				title: 'Day 2: Krabi Four Island Tour',
				desc: 'After breakfast at the hotel, you will be picked up and head to Pattaya Beach where the speedboat takes you over to the beautiful Koh Larn Coral Island. As you arrive, be amazed by its vast white-sand beaches and crystal-clear blue water. Plan your stay how you like it—either relax on the beach, snooze in the sun, swim in the ocean, or try out some water sports, including waterskiing, parasailing, and windsurfing (for an additional fee and subject to availability). After working up an appetite, enjoy a delicious lunch of Thai dishes at a basic, yet pleasant, open-air restaurant right next to the beach. After an action-packed or relaxed day, the speedboat brings you back to Pattaya Beach, where your shuttle bus returns you to your hotel. Rest of the day is free for you to relax and enjoy Pattaya.',
			},
			{
				title: 'Day 3: Transfer From Pattaya To Bangkok',
				desc: 'The journey to Krabi 4 Islands takes a lot of time. In most cases it best advised to do Krabi 4 Islands while staying in Krabi as it is less hectic.',
			},

			{
				title: 'Day 4: Full Day Phi Phi Island Tour',
				desc: 'After breakfast, you will start for the Phi Phi Island Tour. Phi Phi Islands comprise of six islands, of which the prominent ones are Phi Phi Don, which house the Bohemian Town and the Phi Phi Leh with Maya Bay. These islands are visited by hundreds of tourists for their limestone cliffs that rise out of the emerald green waters, white sand beaches and its beautiful coral reefs. Please note it takes about 2 hours one way to reach Phi Phi Island by Big Boat and 1 hour by a Speed boat. You can opt to do snorkeling (by paying National Park Fees) once you reach Phi Phi Island. Enjoy the beach and relax with a local lunch. Return back to the hotel in the evening for overnight stay.',
			},
			{
				title: 'Day 5: Half Day Phuket City Tour',
				desc: 'Today you will head for the Phuket Half-Day City Tour. Drive along scenic beach roads via Patong, Karon and Kata beach with a stop at Karon/Kata beach. Visit the Karon viewpoint, one of the most frequented viewpoints in Phuket, where you can see the three beaches, Kata, Kata Noi and Karon. Next, visit the largest and most revered Chalong Temple built in 1837. Experience the old world charm of Phuket Town with its colonial Sino-Portuguese architecture. Pay a visit to the Cashew Nut factory and shop for local products. Later return to hotel and relax.Participants must wear appropriate clothing. Shorts and miniskirts are strictly not allowed inside Thai temples',
			},
			{
				title: 'Day 6: Departure From Phuket',
				desc: 'After breakfast, checkout from your hotel. You will be picked up and transfered to the airport to catch your flight back home. Your trip ends with sweet memories.',
			},
		],
		flight: [
			{
				dep: 'Delhi (DEL)',
				deptime: '04:40',
				arr: 'Phuket (HKT)',
				arrtime: '10:45',
				airline: 'G8',
			},
			{
				dep: 'Phuket (HKT)',
				deptime: '11:45 ',
				arr: 'Delhi (DEL)',
				arrtime: '14:55',
				airline: 'G8',
			},
		],
		accommodation: [
			{
				roomType: 'Standard',
				name: 'GLOW Ao Nang Krabi or Similar',
				meal: 'Breakfast',
				night: '2N',
			},
			{
				roomType: 'Standard',
				name: 'Best Western Patong Beach - SHA Extra Plus or Similar',
				meal: 'Breakfast',
				night: '3N',
			},
		],
	},
	{
		title: 'Wonders of Europe (Summer 2023)',
		day: 13,
		night: 12,
		image:
			'https://cdn.yourholiday.me/static/dynimg/itinerary/38/600x300/2990875-2990874_swiss.jpg',
		amount: '260,999',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/itinerary/38/600x300/2990875-2990874_swiss.jpg',
		],
		Itinerary: [
			{
				title:
					'Day 1: Arrive Into Paris - The City Of Romance, Lights And Glamour',
				desc: 'Welcome! Today we board our flight to one of the most beautiful & fashionable city - Paris. Get greeted by your Friendly Travel Professional on arrival, who will later escort you to your hotel and assist with your check in. After check in relax in the comfort of your hotel.Overnight in Paris. (Dinner)',
			},
			{
				title:
					'Day 2: Guided City Tour Of Paris. Visit To Eiffel Tower 2nd Level. Enjoy A Romantic Cruise On The River Seine.',
				desc: 'Today we proceed for a guided city tour of Paris. Marvel at the finest Parisian tourist attractions, Place Vendôme, Place de l’Opéra Garnier, Musée d’Orsay, Place de la Concorde, Champs Elysées, one of the most recognised fashionable avenues in the world, Arc de Triomphe, Alexander Bridge, Les Invalides and several others. Next we visit the iconic Eiffel Tower – 2nd Level, and get a stunning view of the city from the top. With its famous tapering cast iron tip, the Eiffel Tower is not just the symbol of Paris but of all of France. Next we take a romantic cruise down the river Seine, one of the world’s most scenic cruise, flanked by exquisite monuments like Notre Dame, Eiffel Tower, Louvre, Orsay Museum and many more. Gliding under one bridge to one another with a view of the finest monuments in the heart of bustling Paris.Overnight in Paris. (Breakfast, Lunch, Dinner)',
			},
			{
				title: 'Day 3: Enjoy Your Fun Filled Day At Disneyland® Paris',
				desc: 'This day experience a day full of excitement at this popular amusement park. The destination to relax and enjoy different kind of thrill rides and studio movies with your loved ones. You may choose between Disney Parks, where fairy tales take flight across five incredible lands filled with classic attractions, shows and street parades with Disney Characters OR you may visit the Walt Disney Studios Park and be astounded by the outstanding stunt shows, watch a film being made and see real-life sets used for creating blockbuster movies.Overnight in Paris. (Breakfast, Lunch, Dinner)',
			},

			{
				title:
					'Day 4: Onto Brussels. Visit Grand Place And Manneken Pis Statue Photo Stop At Atomium',
				desc: 'Today we proceed to Brussels, Headquarters of the European Union and capital of Belgium. On arrival in Brussels we visit one of Europe’s most beautiful squares, the Grand Place, home to the medieval Town Hall and the fabled Manneken Pis statue. Drive past St. Michael’s Church and stop for a photograph at the Atomium. Later we proceed to Netherlands where we stop for overnight stay.Overnight in Netherlands. (Breakfast, Lunch, Dinner)',
			},
			{
				title:
					'Day 5: Explore Amsterdam With Canal Cruise. Visit Keukenhof Gardens (Till 15th May) Or Visit The Miniature Park – Madurodam. (From 16th May)',
				desc: 'Check out and proceed to the Dutch capital Amsterdam. Relax in your coach as we proceed to the city of Lisse to tour the legendary Keukenhof Gardens (till 15th May). Be astounded by the vast numbers of tulips, daffodils and hyacinths, that create dazzling ranges of colour. From 16th May we visit Madurodam a miniature park to see a range of perfect 1:25 scale model replicas of famous Dutch landmarks, historical cities and large developments. Feel like a giant amidst models of palaces, canals, windmills, harbours, airport and other Holland attractions.Board a glass-topped boat where you will experience the best of this historical city. Thrive on the city’s vibrant past with its 1,000 bridges and quaint old houses. We then drive towards Cologne, a 2000 years old city spanning the Rhine river and famous for Eau de Cologne.Overnight in Germany. (Breakfast, Lunch, Dinner)',
			},
			{
				title:
					'Day 6: See The Mercedez Museum. Travel To The Heart Of The Black Forest. See The Largest Waterfall In Switzerland - The Rhine Falls.',
				desc: 'Check out, relax in your coach as today’s day will be a charming experience for any car enthusiast. We will be visiting the Mercedes Benz Museum which covers history of the Mercedes-Benz brand and the brands associated with it till date. (On Monday’s when the museum is closed, you will be taken on a boat ride at the Rhine Falls) Later continue your drive to the heart of the Black Forest, known for its dense, evergreen forests and picturesque villages. You will be enthralled at the scenic beauty of the quaint villages in the heart of Black Forest region. Witness a demonstration of how cuckoo clocks are made. Sit back and enjoy the scenic drive towards Switzerland. Visit Schaffhausen, where you see the magnificent Rhine Falls – Europe’s biggest and most spectacular falls. Incase of museum being closed, we will be opting for a thrilling experience at Rhine Falls with a boat ride. Witness the magnificent falls as we sail upclose to the falls. Later drive to your hotel.Overnight in Zurich. (Breakfast, Lunch, Dinner)',
			},
			{
				title:
					'Day 7: A Magical Alpine Excursion To The Top Of Europe - The Amazing Jungfraujoch And Scenic Interlaken. (Optional Tour At Extra Cost)',
				desc: 'Get set for a memorable magical alpine excursion to Jungfraujoch – The Top of Europe, a high–point of your tour. This tour is not included and can be added at extra cost. First we proceed to Grindelwald Terminal. The new 3S-Bahn Eiger Express takes you from the Grindelwald Terminal to the Eigergletscher station in just 15 minutes. There you board a cogwheel train to reach the highest railway station in Europe at 11,333 feet – a world of eternal ice and snow. Visit the Ice Palace where artistes create their work of art in ice. Visit the Sphinx observatory deck to experience a breath-taking panoramic view of the longest glacier in the Alps - Aletsch Glacier.Overnight in Central Switzerland. (Breakfast, Lunch, Dinner)',
			},
			{
				title:
					'Day 8: Visit Mt. Titlis- Enjoy The World’s First Rotating Cable Car, The Rotair – To The Top Of Mt. Titlis At 3,020 Metres',
				desc: 'Today enjoy amazing scenery, a once in a lifetime experience with an exhilarating trip to the top of Mt Titlis at 3020 metres on various cable cars including Rotair, the world’s first revolving cable car. Get a breath taking unrestricted 360 degrees stunning view of the dazzling snow caped peak, deep crevasses and pristine white snow fields, dotted with massive ice boulders from every angle. Do not forget to visit the “Cliff Walk” the highest suspension bridge in Europe along the cliff of Mt.Titlis. Later proceed on an orientation tour of Lucerne one of most beautiful cities in Switzerland. Visit the Lion Monument, Kapell Brucke with some free time to shop for famous Swiss watches, knives and chocolates.Overnight in Central Switzerland. (Breakfast, Lunch, Dinner)',
			},
			{
				title:
					'Day 9: Drive To Vaduz, The Capital At The Principality Of Liechtenstein. Visit Swarovski Crystal Museum – The Dazzling World Of Crystals. Visit Innsbruck – The Tyrolean Capital Of Picturesque Austria.',
				desc: 'Relax in your coach as you take a scenic drive to Innsbruck. En route arrive in Vaduz, the capital of Liechtenstein, a tiny principality nestled between Switzerland and Austria. It lies entirely within the Alps and covering an area of just sixty-two square miles. Liechtenstein is the sixth smallest independent nation in the world. It follows a policy of neutrality and is one of the few countries in the world that maintains no military. Next proceed to Wattens, to visit the Swarovski World of Crystals and marvel at the crystalline works of art. Later enjoy an orientation tour of the beautiful city, Innsbruck. See the Golden Roof with its fire gilded copper tiles, a characteristic landmark of Innsbruck, walk down cobblestone pathways of Maria Theresien Strasse. You can sit at one of the many outdoor cafes, admire the magnificent baroque architecture and relive medieval European culture. The splendid Alps in the background provide a perfect picture-postcard setting.Overnight in Innsbruck. (Breakfast, Lunch, Dinner)',
			},
			{
				title:
					'Day 10: Welcome To Venice - The Floating City Of Italy. Enjoy Gondola Ride.',
				desc: 'Check out of your hotel and proceed towards Venice – Italy. City of Beautiful Monuments, Serpentine Canals, city that inspired poetry and passion through the ages. Arrive at the pier in Venice, where we board a private boat. Enjoy your ride while you sail over the Giudecca Canal, to arrive at St. Mark’s Square – the main square of Venice. View St Mark’s Basilica - one of the best examples of Byzantine architecture.Witness the famed Bell Tower and Clock Tower with the dominant sign of the Zodiac and current phase of the moon. See the Bridge of Sighs, made of white lime stone, that passes over the Rio di Palazzo, connecting the old prisons with interrogations rooms at the Doge’s Palace. Treasure a romantic Gondola ride in a flat bottomed Venetian rowing boat, amidst the stunning backdrop of baroque buildings. This truly is the best way to enjoy this enchanting city. We return to the pier and later check in to your hotel.Overnight in Padova. (Breakfast, Lunch, Dinner)',
			},
			{
				title: 'Day 11: View The Remarkable And Famous Leaning Tower Of Pisa.',
				desc: 'This morning check out and drive to Florence – the cradle of the Renaissance. View the Duomo – the city’s most iconic landmark, the Campanile and the Baptistery with its Gates to Paradise. Also see the Piazza Della Signoria – an open-air museum crammed with Renaissance sculptures, edged by historic cafes and presided over by the magnificent Palazzo Vecchio and the famed Ponte Vecchio (bridge) across the River Arno. Next, drive to Piazzale Michelangelo to get a spectacular panoramic view of the city. Later proceed towards Pisa. On arrival see the Square of Miracles with the stupendous Leaning Tower of Pisa.Overnight in Florence region. (Breakfast, Lunch, Dinner)',
			},
			{
				title:
					'Day 12: All Roads Lead To Rome – The Eternal City. Visit The World’s Smallest Country – The Vatican City & St. Peter’s Basilica',
				desc: 'Today check-out and proceed towards the eternal city of Rome. Enjoy a guided city tour of Rome with an expert English-speaking local guide. Next visit the Vatican City – the smallest country in the world (Please note shorts or sleeveless vests are not allowed). Visit the divinely beautiful basilica of St. Peter’s. Get mesmerized by the works of Michelangelo and Bernini. We continue and then drive to view the magnificent Colosseum, a vast amphitheatre that is still well preserved. Next, Visit the beautiful Trevi Fountains. The Legend says that tossing a coin over your shoulder gets you back to Rome. Later we drive back to Arezzo for overnight stay.Overnight in Arezzo. (Breakfast, Lunch, Dinner)',
			},
			{
				title: 'Day 13: Shopping At Mcarthurglen Outlet - Fly Back Home',
				desc: 'Today morning after breakfast, proceed for shopping at McArthurGlen shopping outlet. It offers you discounts between 50-70% off on brands and because you are on this tour, you can avail an additional 10% on all shopping.Later we make our way for the Airport with pleasant memories of your European trip which you will cherish for a lifetime.(Breakfast)',
			},
		],
		flight: [
			{
				dep: 'To and Fro Flights Included (into Paris out of Milan)',
			},
		],
		accommodation: [
			{
				roomType: 'Standard',
				name: 'Novotel Massy Palaiseau or Similar',
				meal: 'Breakfast',
				night: '3N',
			},
			{
				roomType: 'Standard',
				name: 'Fletcher Hotel-Restaurant Amersfoort or Similar',
				meal: 'Breakfast',
				night: '1N',
			},
			{
				roomType: 'Standard',
				name: 'Michel Hotel Heppenheim or Similar',
				meal: 'Breakfast',
				night: '1N',
			},
			{
				roomType: 'Standard',
				name: 'Sihlpark Hotel and Spa or Similar',
				meal: 'Breakfast',
				night: '3N',
			},
			{
				roomType: 'Standard',
				name: 'Alphotel or Similar',
				meal: 'Breakfast',
				night: '1N',
			},
			{
				roomType: 'Standard',
				name: 'UNAWAY Hotel Occhiobello or Similar',
				meal: 'Breakfast',
				night: '1N',
			},
			{
				roomType: 'Standard',
				name: 'Hotel Planet or Similar',
				meal: 'Breakfast',
				night: '1N',
			},
			{
				roomType: 'Standard',
				name: 'Hotel Planet or Similar',
				meal: 'Breakfast',
				night: '1N',
			},
		],
	},
	{
		title: 'Romantic Switzerland and Paris (Summer 2023)',
		day: 10,
		night: 9,
		image:
			'https://cdn.yourholiday.me/static/dynimg/itinerary/92/600x300/2993422-2993421_picture1-min-12.jpg',
		amount: '241,999',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/itinerary/92/600x300/2993422-2993421_picture1-min-12.jpg',
		],
		Itinerary: [
			{
				title:
					'Day 1: Arrival At Geneva - Transfer To Lausanne - Visit The Olympic Museum',
				desc: 'Welcome to Switzerland! You will be greeted by your friendly Travel Professional outside the baggage hall. Next, we then proceed to a very conveniently located hotel to check-in near Lake Geneva. Later we visit the world famous Olympic Museum at Laussane. Step into the museum’s 3000 square meters of exhibition space, featuring over 1500 exhibits and 150 screens to create the ultimate visitor experience. From the permanent exhibition to the Olympic Park and the TOM Café, you’ll leave with memorable stories to tell. Overnight in Lake Geneva Region.Dinner',
			},
			{
				title: 'Day Trip To Gstaad - Glacier 3000',
				desc: 'Breakfast at the hotel. Today visit Glacier 3000 near Gstaad. Travel by cable car to the Glacier 3000. Once on top, there are various activities for young and old. The 1 kilometre Alpine Coaster, the world’s highest bobsleigh track, is a must. There are also husky dog sled rides, the snow bus and skiing galore. There are also 2 restaurants- Botta 3000 and the Oldegg where you can enjoy anything from small snacks to local specialities with the spectacular view thrown in for free. While returning back you can opt to spend a couple of hours at the small town of Gstaad. This gorgeous walking city boasts a high-end and sophisticated aura that attracts celebs and world-travelers from all over. Gstaad can be considered the more exclusive and local alternative to St. Moritz – with it’s luxurious charm and upscale environment. Return to your hotel after a fun filled day. Overnight in Lake Geneva Region.Breakfast, Lunch and Dinner',
			},
			{
				title:
					'Day 3: Lavaux Vineyards - Unesco World Heritage Site - Chocolate Factory And The Chillon Castle',
				desc: 'After breakfast we begin our day with a trip to the Lavaux Vineyards. A trip to the terraced Lavaux Vineyards is at the top of most visitors hit lists. Take a stroll through the labyrinth of vines or hop on a train tour around the UNESCO World Heritage Site before heading to the wine cellar to sample the regions beloved Chasselas wine. We continue our journey to Maison Cailler-Nestlé chocolate factory. Learn everything about the history of Swiss chocolate making tradition followed by chocolate tasting. We stop by Montreux on the way back where you can click some pics outside the statue of Freddie Mercury on the banks of Lake Geneva. Visit one of Switzerland’s most magnificent and historic locations, the Chateau Chillon, located on the shores of Lake Geneva. Explore the Castle’s courtyards and its underground area where Gothic-style vaults and numerous legends await you. Wander the Great Halls, where the Savoy family held their sumptuous banquets, or visit the rooms in which the Duke of Savoy and his family spent their everyday life. Overnight stay in the Lake Geneva Region.(Breakfast, Lunch and Dinner)',
			},

			{
				title:
					'Day 4: Proceed To Zurich - Berne Orientation Tour - Shopping In Zurich',
				desc: 'After breakfast we leave for Zurich. On the way we stop in Bern, the capital city of Switzerland. We stop by the Clock Tower and outside Einstein house for some photos. Albert Einstein house in Bern is where he developed his famous theory of relativity. Later we reach Zurich and check in. Spend the evening exploring Zurich town, shopping at the Bahnofstrasse or visiting the Fraumunster church. Overnight in Zurich.(Breakfast, Lunch and Dinner)',
			},
			{
				title:
					'Day 5: Visit Mt. Titlis- Enjoy Cable Car Rides Including The World’s First Rotating Cable Car, The Rotair – To The Top Of Mt. Titlis At 3,020 Metres',
				desc: 'Today enjoy amazing scenery, a once in a lifetime experience with an exhilarating tip to the top of Mt Titlis at 3020 metres on various cable cars including Rotair, the world’s first revolving cable car. Get a breath taking unrestricted 360 degrees stunning view of the dazzling snow caped peak, deep crevasses and pristine white snow fields, dotted with massive ice boulders from every angle. Do not forget to visit the “Cliff Walk” the highest suspension bridge in Europe along the cliff of Mt.Titlis. Later proceed on an orientation tour of Lucerne one of most beautiful cities in Switzerland. Visit the Lion Monument, Kapell Brucke with some free time to shop for famous Swiss watches, knives and chocolates.(Breakfast, Lunch and Dinner)',
			},
			{
				title:
					'Day 6: A Magical Alpine Excursion To The Top Of Europe - The Amazing Jungfraujoch And Scenic Interlaken. (Optional Tour At Extra Cost)',
				desc: 'Get set for a memorable magical alpine excursion to Jungfraujoch – The Top of Europe, a high–point of your tour. This tour is not included and can be added at extra cost. First we proceed to Grindelwald Terminal. The new 3S-Bahn Eiger Express takes you from the Grindelwald Terminal to the Eigergletscher station in just 15 minutes. There you board a cogwheel train to reach the highest railway station in Europe at 11,333 feet – a world of eternal ice and snow. Visit the Ice Palace where artistes create their work of art in ice. Visit the Sphinx observatory deck to experience a breath-taking panoramic view of the longest glacier in the Alps - Aletsch Glacier.Overnight in Zurich. (Breakfast, Lunch, Dinner)',
			},
			{
				title:
					'Day 7: Breath Taking Rhine Falls At Schaffhausen - Arrive At Paris',
				desc: 'This morning after the buffet breakfast Stop at Schaffhausen where you will see the magnificent Rhine Falls - Europe’s biggest and most spectacular falls. Later relax in your coach as we proceed to the beautiful city of Paris. The journey is a bit long so we arrive by early evening. You have free time at night to opt for shows like the Moulin Rouge (at additional costs) or explore Paris in night Overnight stay at Paris.(Breakfast, Lunch and Dinner)',
			},
			{
				title:
					'Day 8: Guided City Tour Of Paris. Visit To Eiffel Tower 2nd Level. Enjoy A Romantic Cruise On The River Seine.',
				desc: 'Today we proceed for a guided city tour of Paris. Marvel at the finest Parisian tourist attractions, Place Vendôme, Place de l’Opéra Garnier, Musée d’Orsay, Place de la Concorde, Champs Elysées, one of the most recognised fashionable avenues in the world, Arc de Triomphe, Alexander Bridge, Les Invalides and several others. Next we visit the iconic Eiffel Tower – 2nd Level, and get a stunning view of the city from the top. With its famous tapering cast iron tip, the Eiffel Tower is not just the symbol of Paris but of all of France. Later in the day, visit Montmartre known for its artist’s history. Take a Funicular to the top and see the white domed Basilica of Sacre-Coeur, a popular landmark and the second most visited Monument of Paris. Next we take a romantic cruise down the river Seine, one of the world’s most scenic cruise, flanked by exquisite monuments like Notre Dame, Eiffel Tower, Louvre, Orsay Museum and many more. Gliding under one bridge to one another with a view of the finest monuments in the heart of bustling Paris.Overnight in Paris.(Breakfast, Lunch and Dinner)',
			},
			{
				title: 'Day 9: Enjoy Your Fun Filled Day At Disneyland Paris',
				desc: 'This day experience a day full of excitement at this popular amusement park. The destination to relax and enjoy different kind of thrill rides and studio movies with your loved ones. You may choose between Disney Parks, where fairy tales take flight across five incredible lands filled with classic attractions, shows and street parades with Disney Characters OR you may visit the Walt Disney Studios Park and be astounded by the outstanding stunt shows, watch a film being made and see real-life sets used for creating blockbuster movies. Overnight in Paris.(Breakfast, Lunch and Dinner)',
			},
			{
				title: 'Day 10: Fly Back Home',
				desc: 'Your memorable holiday ends, today it’s time to fly back home. Say goodbye to the wonderful new friends you have made on the tour. Check out and depart for the Airport with pleasant memories of your European trip which you will cherish for a lifetime.(Breakfast)',
			},
		],
		flight: [
			{
				dep: 'To and Fro Flights in Economy Class (into Geneva out of Paris)',
			},
		],
		accommodation: [
			{
				roomType: 'Standard',
				name: 'Hotel Continental or Similar',
				meal: 'Breakfast',
				night: '3 night(s) in Lausanne',
			},
			{
				roomType: 'Standard',
				name: 'Swiss-Belhotel Du Parc Baden or Similar',
				meal: 'Breakfast',
				night: '3 night(s) in Zurich',
			},
			{
				roomType: 'Standard',
				name: 'Mercure Paris CDG Airport & Convention Hotel or Similar',
				meal: 'Breakfast',
				night: '3 night(s) in Paris',
			},
		],
	},
];
const CarouselHoliday = () => {
	// const { hotel } = useSelector((state) => state.home);
	const dispatch = useDispatch();
	const history = useHistory();
	const responsive = {
		0: { items: 1 },
		568: { items: 2 },
		1024: { items: 4 },
	};
	const items = data.map((i, index) => {
		return (
			<div
				onClick={() => history.push({ pathname: '/detail', state: i })}
				style={{ cursor: 'pointer', marginTop: 20 }}
				className='item'
				data-value='1'>
				<Box style={{ width: '90%' }}>
					<Box>
						<img
							src={i.image}
							style={{ width: '100%', height: 160, borderRadius: 5 }}
						/>
					</Box>
					<Box style={{ textAlign: 'initial', padding: 10 }}>
						<span
							style={{
								color: '#0c2f54',
								fontFamily: '"Lato", sans-serif',
								fontWeight: 'bold',
								fontSize: 14,
							}}>
							{i.title}
						</span>
						<br></br>
						<Box display='flex' alignItems='center' style={{ marginTop: 5 }}>
							<Box display='flex' alignItems='center'>
								<i class='far fa-clock'></i>
								<span
									style={{
										color: '#0c2f54',
										fontFamily: '"Lato", sans-serif',
										fontWeight: 'bold',
										marginLeft: 5,
										fontSize: 14,
									}}>
									{i.day} Days
								</span>
							</Box>
							<Box display='flex' alignItems='center' ml={'10px'}>
								<i class='far fa-moon'></i>
								<span
									style={{
										color: '#0c2f54',
										fontFamily: '"Lato", sans-serif',
										fontWeight: 'bold',
										marginLeft: 5,
										fontSize: 14,
									}}>
									{i.night} Nights
								</span>
							</Box>
						</Box>
						<Box display='flex' alignItems='center' style={{ marginTop: 5 }}>
							<Box display='flex' alignItems='center'>
								{/* <i class='far fa-clock'></i> */}
								<span
									style={{
										color: '#0c2f54',
										fontFamily: '"Lato", sans-serif',
										fontWeight: 'bold',
										marginLeft: 5,
										fontSize: 16,
									}}>
									₹ {i.amount}
								</span>
							</Box>
						</Box>
					</Box>
					{/* <Box style={{ background: '#0c2e53', padding: 10 }}>
						<span style={{ color: 'white' }}> Starting From ₹{800} </span>
					</Box> */}
				</Box>
			</div>
		);
	});
	const demo = [
		<div className='item' data-value='1'>
			1
		</div>,
		<div className='item' data-value='2'>
			2
		</div>,
		<div className='item' data-value='3'>
			3
		</div>,
		<div className='item' data-value='4'>
			4
		</div>,
		<div className='item' data-value='5'>
			5
		</div>,
	];

	return (
		<AliceCarousel
			autoPlay
			infinite
			mouseTracking
			items={items}
			autoPlayInterval={3000}
			responsive={responsive}
			controlsStrategy='alternate'
			keyboardNavigation={true}
			renderPrevButton={() => {
				return <></>;
			}}
			renderNextButton={() => {
				return <></>;
			}}
		/>
	);
};

export default CarouselHoliday;
